import {getCurrentYear} from '../../utils/commons'
import TechGearAdvisorsLogo from './logo'
import {techGearAdvisorsStylesUS} from './styles'

const baseConfig = {
  domainName: 'techgearadvisors' as const,
  domainType: 'insider' as const,
  siteName: 'Tech Gear Advisors',
  logo: <TechGearAdvisorsLogo className="size-10 shrink-0 tablet:size-8" />,
  favicon: '/favicons/techgearadvisors.png',
}

const localeConfigs = {
  us: {
    measurementId: 'G-890M60KLVS',
    camelCaseUrl: 'TechGearAdvisors.com',
    title: (category: string, _count: string) =>
      `${category} Worth Buying in ${getCurrentYear()} — Our Top Picks | TechGearAdvisors.com`,
    description: (_category?: string, _count?: string) =>
      `TechGearAdvisors.com evaluates top electronics products with expert analysis and verified user feedback. Discover recommended options you'll value this year.`,
    styles: techGearAdvisorsStylesUS,
  },
}

export const createConfig = (locale: string = 'us') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.us
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
